<template>
  <div class="moduleFour">
    <slot></slot>
    <el-carousel type="card" :interval="5000" :height="styleObject.height">
      <el-carousel-item v-for="(item, index) in mod4.newsDtos" :key="index">
        <div class="div" @click="hrefUrl(item.url,item.id,item.type)">
          <a><img :src="item.img"/></a>
          <div>{{ item.title }}</div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="contentSty" v-show="contenShow">
      <div class="title">
        <p class="circle"></p>
        <p class="text">公司资讯</p>
        <p class="circle"></p>
      </div>
      <div class="contentList">
        <ul>
          <li v-for="(item, index) in contentList" :key="index"><a :href="item.url+'?id='+item.serialNo" target="view_window">{{ item.title }}</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["mod4"],
  data() {
    return {
      styleObject: {
        height: ""
      },
      contentList: [],
      contenShow: false
    };
  },
  mounted() {
    this.innerHeight();
  },
  methods: {
    innerHeight() {
      this.styleObject.height = (window.innerHeight / 6) * 2.5 + "px";
    },
    hrefUrl(url, id, type) {
      if (type == "002") {
        this.contenShow = !this.contenShow;
        this.getContent(id);
        return;
      };
      window.location.href = url;
      this.contenShow = false;
    },
    getContent(id) {
      axios.get("/api/home/queryNewsList?id=" + id, {}).then(res => {
        this.contentList = res.data.data;
      });
    }
  },
  watch: {
    mod4(val) {
      console.log(val, "mod4");
    }
  }
};
</script>

<style lang="sass">
.moduleFour
  white-space: normal
  word-break: break-all;overflow:hidden
  padding-bottom: 45px
  text-align: center
  font-size: 25px
  position: relative
  .el-carousel__item h3
    color: #475669
    font-size: 18px
    opacity: 0.75
    line-height: 300px
    margin: 0
  .div
    height: 100%
    a
      img
        width: 100%
        height: 80%
    div
      margin: auto
  .el-carousel__item:nth-child(2n)
    background-color: #99a9bf
  .el-carousel__item:nth-child(2n+1)
    background-color: #d3dce6
  .contentSty
    position: absolute;
    background: #fff;
    height: 100%;
    width: 25%;
    text-align: left;
    top: 0;
    z-index: 99;
    right: 0;
    overflow: auto;
    border: 1px solid #4E6EF2;
    font-size: 14px;
    background-image: linear-gradient(to right, #7e94ed , #274eeb);
    overflow-x: hidden;
    .title
      display: flex;
      justify-content: space-around;
      color: #fff;
      line-height: 7px;
      .circle
        height: 20px;
        width: 20px;
        border-radius: 50%;
        background: #fff;
      .text
        font-size: 22px;
    .contentList
      //margin-left: -10px;
      overflow: hidden
      background: #fff;
      height: 85%;
      width: 95%;
      margin: 0 auto
      overflow: auto
      ul
        list-style-type: circle;
        cursor: pointer;
        margin: 0 10px;
        overflow: hidden;
        padding-top: 10px;
        padding-left: 18px;
        li
          width: 100%;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 50px;
          padding: 0;
          line-height: 50px;
        a
          text-decoration: none;
          color: black;
          &:hover
            color: #4E6EF2;
            border-bottom: 1px solid #4E6EF2;
  .contentList::-webkit-scrollbar
    display: none;
</style>
